<template>
<kt-panel v-if="withPanel">
    <kt-panel-body>
        <div class="kt-datatable" :id="id"></div>
    </kt-panel-body>
</kt-panel>
<div v-else class="kt-datatable" :id="id"></div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import '@/plugins/core/base/datatable/core.datatable'
import '@/plugins/core/base/datatable/datatable.rtl'
import { i18n } from '@/plugins/i18n'
import router from '@/router'

export default {
    props: {
        id: {
            required: true
        },
        data: {
            required: true,
        },
        layout: {
            default: function() {
                return {}
            },
            type: Object
        },
        sortable: {
            default: false,
            type: Boolean
        },
        pagination: {
            default: true,
            type: Boolean
        },
        search: {
            default: function() {
                return {}
            },
            type: Object
        },
        columns: {
            default: function() {
                return []
            },
            type: Array
        },
        actions: {
            type: [HTMLElement, Function]
        },

        withPanel: {
            default: true
        }
    },
    data() {
        return {
            KTDatatable: false,
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        conf() {
            return {
                data: this.data,
                layout: this.layout,
                sortable: this.sortable,
                pagination: this.pagination,
                search: this.pagination,
                columns: [...this.columns, this.actionColumn()],
                translate: {
                    records: this.$t('datatable.records'),
                    toolbar: this.$t('datatable.toolbar'),
                }
            }
        }
    },
    methods: {
        actionColumn() {
            if(
                !(this.actions instanceof HTMLElement
                || this.actions instanceof Function)
            ) {
                return
            }
            
            return {
                field: 'actions',
                title: this.$t('datatable.actions'),
                sortable: false,
                width: 70,
                overflow: 'visible',
                autoHide: false,
                template: (row, index, datatable) => {
                    if(this.actions instanceof HTMLElement) {
                        return this.actions
                    }
                    
                    let template = new this.actions({
                        props: {
                            row,
                            index,
                            datatable,
                        },
                        i18n,
                        router
                    })

                    template.row = row
                    template.index = index
                    template.datatable = datatable

                    return template.$mount().$el
                }
            }
        },
        reload() {
            this.destroy()

            this.$nextTick(() => {
                this.init()
            })
        },
        init() {
            this.KTDatatable = $('.kt-datatable').KTDatatable(this.conf)
        },
        destroy() {
            if (this.KTDatatable) {
                this.KTDatatable.destroy()
            }
        }
    },
}
</script>

<style>
.kt-datatable__pager-size {
    width: 110px!important;
}
</style>

